import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndPrivacy = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service & Privacy Policy</h1>
          
          <section className="mb-10">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Terms of Service</h2>
            <div className="prose prose-lg">
              <p>
                Welcome to ImgAI, an AI-powered image generation service. By using our service, you agree to these terms.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">1. Service Description</h3>
              <p>
                ImgAI provides AI-generated images based on text prompts provided by users. The service is provided &quot;as is&quot; without warranties of any kind.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">2. User Responsibilities</h3>
              <p>
                Users are responsible for the content of their prompts and should not request images that infringe on existing trademarks or contain inappropriate content.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">3. Intellectual Property</h3>
              <p>
                Users retain ownership of the images generated through our service. However, we cannot guarantee that generated images are free from third-party intellectual property claims.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">4. Limitations</h3>
              <p>
                We reserve the right to limit or terminate access to the service at our discretion. The service may have usage limits to prevent abuse.
              </p>
            </div>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Privacy Policy</h2>
            <div className="prose prose-lg">
              <p>
                At ImgAI, we take your privacy seriously. This policy explains how we collect, use, and protect your data.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">1. Data Collection</h3>
              <p>
                We collect the text prompts you provide to generate images. We may also collect usage data such as IP addresses and browser information to improve our service.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">2. Data Usage</h3>
              <p>
                We use your data to provide and improve our service. We may use anonymized prompts to train our AI models to improve image generation quality.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">3. Data Sharing</h3>
              <p>
                We do not sell your personal data. We may share anonymized data with service providers who help us operate our platform.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">4. Data Security</h3>
              <p>
                We implement reasonable security measures to protect your data. However, no method of transmission over the internet is 100% secure.
              </p>
              
              <h3 className="text-xl font-medium mt-6 mb-3">5. Your Rights</h3>
              <p>
                You have the right to access, correct, or delete your personal data. Contact us if you wish to exercise these rights.
              </p>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsAndPrivacy; 